import ComingSoon from "components/ComingSoon";
import React from "react";

const Gmail = () => {
  return <ComingSoon />;
};

export default Gmail;
